import apiRequestCommon from './index'

export default {
  // DT洗車QRデータ取得 API
  path: '/v1/carwash/ss/__SSCODE__/qr',

  async get (ssCode, authid) {
    await window.callNativeHTTPX()
    const headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'APP-USERS-AUTH-ID': authid
    }
    return apiRequestCommon.get(`${this.path.replace(/__SSCODE__/g, ssCode)}`, {
      headers: headersParam
    })
  }
}
